import qs from 'qs';
import apiClient from './apiClient';

export class User {
  public async init() {
    const { token } = qs.parse(window.location.search.replace('?', ''));

    if (typeof token === 'string' && localStorage.getItem('oauth')) {
      this.setToken(token);
    }

    if (this.token) {
      return;
    }
  }

  public get token() {
    return localStorage.getItem('token');
  }

  public get authorized() {
    return !!this.token;
  }

  public logout() {
    localStorage.removeItem('token');
  }

  public async login() {
    await apiClient.base.oauth({ mp: 'gjgj' });
  }

  public setToken(token: string) {
    localStorage.setItem('token', token);
    localStorage.removeItem('oauth');
  }
}

export const user = new User();

const store = {
  user
};

export default store;
